import { useMutation } from '@tanstack/react-query';
import { endpoints } from '@rossum/api-client';
import { api } from '../../../../lib/apiClient';

export const usePostponeAnnotations = () => {
  return useMutation({
    mutationFn: (ids: Array<number>) => {
      const postponeRequests = ids.map(id =>
        api.request(endpoints.annotations.postpone(id))
      );

      return Promise.all(postponeRequests);
    },
  });
};
